'use client';
import * as React from 'react';
import { ChatBox, ChatMessageContent } from '@mui/x-chat';
import { createEchoAdapter } from 'docs/data/chat/core/examples/shared/demoUtils';
import {
  minimalConversation,
  minimalMessages,
} from 'docs/data/chat/core/examples/shared/demoData';

const BubbleWithStatusSlot = React.forwardRef(function BubbleWithStatusSlot(
  { ownerState, children, ...props },
  ref,
) {
  let dotColor = 'transparent';
  if (ownerState?.streaming) {
    dotColor = 'blue';
  } else if (ownerState?.error) {
    dotColor = 'red';
  } else if (ownerState?.status === 'sent') {
    dotColor = 'green';
  }

  return (
    <div ref={ref} {...props}>
      {children}
      <span style={{ color: dotColor, marginLeft: 4 }}>●</span>
    </div>
  );
});

const CustomMessageContent = React.forwardRef(
  function CustomMessageContent(props, ref) {
    return (
      <ChatMessageContent
        ref={ref}
        {...props}
        slots={{ ...props.slots, bubble: BubbleWithStatusSlot }}
      />
    );
  },
);

const adapter = createEchoAdapter();

export default function BubbleWithStatus() {
  return (
    <ChatBox
      adapter={adapter}
      initialActiveConversationId={minimalConversation.id}
      initialConversations={[minimalConversation]}
      initialMessages={minimalMessages}
      slots={{
        messageContent: CustomMessageContent,
      }}
      sx={{
        height: 500,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
      }}
    />
  );
}
